// src/components/common/A4DocumentLayout/A4ProductCell.jsx
import React, { useState } from 'react';
import { getProcurementItemImage } from '../../../utils/imageUtils';
import styles from './A4DocumentLayout.module.css';

// Product cell for A4 item tables: thumbnail (when available) + name + optional SKU line.
const A4ProductCell = ({ item, name, sku }) => {
  const [failed, setFailed] = useState(false);
  const src = getProcurementItemImage(item);
  return (
    <div className={styles.itemCell}>
      {src && !failed
        ? <img src={src} alt="" className={styles.itemThumb} onError={() => setFailed(true)} />
        : <span className={styles.itemThumbEmpty} />}
      <div>
        <strong>{name}</strong>
        {sku && <div className={styles.itemSku}>SKU: {sku}</div>}
      </div>
    </div>
  );
};

export default A4ProductCell;
